//https://icons.getbootstrap.com/icons/bar-chart/

export const NavAdmin = [
  { icon: 'fa fa-list', label: 'Dashboard', to: '/#/' },

  { icon: 'bi bi-chat-left-dots', label: 'Interação', to: '/#/Interacao' },

  {
    icon: 'fa fa-gear',
    label: 'Configurações',
    content: [
      { label: 'Laboratórios', to: '/#/Settings/Laboratorios' },
      { label: 'Normas', to: '/#/Settings/Normas' },
      { label: 'Parâmetros', to: '/#/Settings/Parameters' },
      { label: 'Usuários', to: '/#/Settings/user/Query' },
    ],
  },
]
